import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Form, Table, Spinner, Modal } from "react-bootstrap";
import { getSIVProductInventoryTransactionById, updateSIVProductInventoryTransactionDate } from '../../actions';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class ProductInventoryTransactionView extends Component {
  state = {
    loading: false,
    transaction: null,
    showModal: true,
    isEditingDate: false,
    editedTransactionDate: ''
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    this.loadTransaction(id);
  }

  loadTransaction = (id) => {
    this.setState({ loading: true });
    this.props.getSIVProductInventoryTransactionById(id)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(error => {
        console.error('Error loading transaction:', error);
        alert('Failed to load transaction. See console for details.');
        this.setState({ loading: false });
      });
  };

  handleClose = () => {
    this.setState({ showModal: false }, () => {
      // Sử dụng onHide prop thay vì history.push để tránh reload
      if (this.props.onHide) {
        this.props.onHide();
      } else {
        // Fallback cho trường hợp không có onHide
        this.props.history.push('/admin/fulfill/transactions');
      }
    });
  };

  handleEditDate = () => {
    const { transaction } = this.props;
    this.setState({
      isEditingDate: true,
      editedTransactionDate: transaction.transaction_date ? transaction.transaction_date.split('T')[0] : ''
    });
  };

  handleCancelEditDate = () => {
    this.setState({
      isEditingDate: false,
      editedTransactionDate: ''
    });
  };

  handleSaveDate = () => {
    const { transaction } = this.props;
    const { editedTransactionDate } = this.state;
    
    if (!editedTransactionDate) {
      alert('Please select a transaction date');
      return;
    }

    this.setState({ loading: true });
    
    this.props.updateSIVProductInventoryTransactionDate(transaction._id, editedTransactionDate)
      .then(() => {
        this.setState({
          isEditingDate: false,
          editedTransactionDate: '',
          loading: false
        });
        alert('Transaction date updated successfully');
        // Reload transaction data to get updated values
        this.loadTransaction(transaction._id);
      })
      .catch(error => {
        console.error('Error updating transaction date:', error);
        this.setState({ loading: false });
        alert('Failed to update transaction date. Please try again.');
      });
  };

  handleDateChange = (e) => {
    this.setState({ editedTransactionDate: e.target.value });
  };

  handlePrint = () => {
    const { transaction } = this.props;
    if (!transaction) return;
    // Tạo nội dung HTML cần in
    const printContent = `
      <html>
        <head>
          <title>Transaction Details</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 24px; }
            h2 { text-align: center; margin-bottom: 24px; }
            table { width: 100%; border-collapse: collapse; margin-top: 16px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .section-title { font-weight: bold; margin-top: 16px; }
            .label { font-weight: bold; }
            .value { margin-bottom: 8px; }
          </style>
        </head>
        <body>
          <h2>${getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_DETAILS)}</h2>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_ID)}: <span class="value">${transaction.transaction_id}</span></div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_TYPE)}: <span class="value">${getTranslate(LANGUAGE_KEYS[`TEXT_${transaction.type}`]) || transaction.type}</span></div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_PARTNER)}: <span class="value">${transaction.partner_id || '-'}</span></div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_BY)}: <span class="value">${transaction.updated_by || '-'}</span></div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_CREATED_AT)}: <span class="value">${transaction.created_at ? new Date(transaction.created_at).toLocaleString() : '-'}</span></div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_SYSTEM_NOTE)}:</div>
          <div style="border:1px solid #eee; padding:8px; min-height:32px;">${this.formatSystemNote(transaction.system_note) || ''}</div>
          <div class="section-title">${getTranslate(LANGUAGE_KEYS.TEXT_STAFF_NOTE)}:</div>
          <div style="border:1px solid #eee; padding:8px; min-height:32px;">${transaction.staff_note || ''}</div>
          <div class="section-title" style="margin-top:24px;">${getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_DETAILS)}</div>
          <table>
            <thead>
              <tr>
                <th>${getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE)}</th>
                <th>${getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
              </tr>
            </thead>
            <tbody>
              ${(transaction.items || []).map(item => `
                <tr>
                  <td>${item.product_code}</td>
                  <td>${transaction.type === 'EXPORT' ? Math.abs(item.quantity_change) : item.quantity_change}</td>
                </tr>
              `).join('')}
              <tr style="background:#eaf6ff; font-weight:bold;">
                <td style="text-align:right;">${getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ITEMS)}: ${transaction.items?.length || 0}</td>
                <td style="text-align:right;">${getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_QUANTITY)}: ${transaction.items?.reduce((sum, item) => sum + (transaction.type === 'EXPORT' ? Math.abs(parseInt(item.quantity_change) || 0) : (parseInt(item.quantity_change) || 0)), 0) || 0}</td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    `;
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  formatMonthlyIdToHuman = (monthlyId) => {
    if (!monthlyId || typeof monthlyId !== 'string' || monthlyId.length < 7) return monthlyId;
    // Lấy tháng
    const month = parseInt(monthlyId.substring(2, 4), 10);
    // Lấy số thứ tự (bỏ các số 0 đầu)
    const orderNum = parseInt(monthlyId.substring(4), 10);
    if (isNaN(month) || isNaN(orderNum)) return monthlyId;
    return `T${month}.${orderNum}`;
  };

  formatSystemNote = (note) => {
    if (!note) return '';
    // Split by comma and format each monthly ID
    return note.split(',').map(id => this.formatMonthlyIdToHuman(id.trim())).join(', ');
  };

  render() {
    const { loading, showModal } = this.state;
    const { transaction } = this.props;

    // Calculate totals if transaction exists
    const totalQuantity = transaction?.items?.reduce(
      (sum, item) =>
        sum + (transaction.type === 'EXPORT'
          ? Math.abs(parseInt(item.quantity_change) || 0)
          : (parseInt(item.quantity_change) || 0)
        ),
      0
    ) || 0;
    const totalItems = transaction?.items?.length || 0;

    return (
      <Modal show={showModal} onHide={this.handleClose} size="lg" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_DETAILS)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <span className="ms-2">Loading transaction...</span>
            </div>
          ) : !transaction ? (
            <div className="text-center">
              <h3>Transaction not found</h3>
            </div>
          ) : (
            <Container fluid>
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_ID)}</Form.Label>
                    <Form.Control
                      type="text"
                      value={transaction.transaction_id}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_TYPE)}</Form.Label>
                    <Form.Control
                      type="text"
                      className={transaction.type === 'IMPORT' ? 'text-success fw-bold' : transaction.type === 'EXPORT' ? 'text-danger fw-bold' : ''}
                      value={getTranslate(LANGUAGE_KEYS[`TEXT_${transaction.type}`]) || transaction.type}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PARTNER)}</Form.Label>
                    <Form.Control
                      type="text"
                      value={transaction.partner_id || '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_BY)}</Form.Label>
                    <Form.Control
                      type="text"
                      value={transaction.updated_by || '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Transaction Date</Form.Label>
                    <div className="d-flex">
                      {this.state.isEditingDate ? (
                        <Form.Control
                          type="date"
                          value={this.state.editedTransactionDate}
                          onChange={this.handleDateChange}
                          className="me-2"
                        />
                      ) : (
                        <Form.Control
                          type="text"
                          value={transaction.transaction_date ? new Date(transaction.transaction_date).toLocaleDateString('vi-VN') : '-'}
                          disabled
                          className="me-2"
                        />
                      )}
                      {this.state.isEditingDate ? (
                        <>
                          <Button variant="success" size="sm" onClick={this.handleSaveDate} className="me-1">
                            Save
                          </Button>
                          <Button variant="secondary" size="sm" onClick={this.handleCancelEditDate}>
                            Cancel
                          </Button>
                        </>
                      ) : (
                        <Button variant="outline-primary" size="sm" onClick={this.handleEditDate}>
                          Edit
                        </Button>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CREATED_AT)}</Form.Label>
                    <Form.Control
                      type="text"
                      value={transaction.created_at ? new Date(transaction.created_at).toLocaleString() : '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SYSTEM_NOTE)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.formatSystemNote(transaction.system_note) || ''}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_STAFF_NOTE)}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={transaction.staff_note || ''}
                      disabled
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={12}>
                  <h4>{getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_DETAILS)}</h4>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE)}</th>
                        <th>{getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transaction.items && transaction.items.map((item, index) => (
                        <tr key={index}>
                          <td>{item.product_code}</td>
                          <td>{transaction.type === 'EXPORT' ? Math.abs(item.quantity_change) : item.quantity_change}</td>
                        </tr>
                      ))}
                      <tr className="table-info">
                        <td className="text-end fw-bold">
                          {getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ITEMS)}: {totalItems}
                        </td>
                        <td className="text-end fw-bold">
                          {getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_QUANTITY)}: {totalQuantity}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Container>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={this.handlePrint}>
            {getTranslate(LANGUAGE_KEYS.TEXT_PRINT) || 'Print'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  transaction: state.sivProductInventoryTransactionReducer.currentTransaction
});

export default connect(mapStateToProps, {
  getSIVProductInventoryTransactionById,
  updateSIVProductInventoryTransactionDate
})(ProductInventoryTransactionView); 